import { Col, Progress } from 'antd';
import { get } from 'lodash-es';

import { DashboardCard } from '@page/dashboard/dashboard.page-style';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Row } from '@atom/grid/row/row';
import { Title } from '@atom/typography/typography';
import { PlanPaidDescription } from '@component/billing/plans/plan-paid';
import { RouteEnum } from '@enum/route.enum';
import { useLoadPlansQuery } from '@hook/billing/billing.hooks';
import { useSubscription } from '@hook/billing/subscription.hook';
import { useMemberRole } from '@hook/memeber/use-member-role.hook';
import { useMedia } from '@hook/style/use-media.hook';
import { isExist } from '@util/data/is-exist';

import { BillingPlanFreeDescription } from './plans/plan-free';

export const Billing = () => {
  const { isMobile } = useMedia();
  const subscription = useSubscription();
  const { data } = useLoadPlansQuery();
  const { isOwner } = useMemberRole();

  const isBasePlan = get(subscription, ['data', 'plan', 'isBasePlan']);
  const subscriptionName = get(subscription, ['data', 'plan', 'name']);
  const limitApiCalls = get(subscription, ['data', 'plan', 'limits', 'apiCalls']);
  const usedApiCalls = get(subscription, ['data', 'used', 'apiCalls']);

  const currentSubscriptionPlanId = get(subscription, ['data', 'plan', 'id']);
  const subscriptionPlan =
    get(data, 'data', []).find((plan) => plan.id === currentSubscriptionPlanId) ??
    get(data, 'data', []).find((plan) => plan.isBasePlan);

  return (
    <Row gutter={[24, 24]} vertical>
      <Col span={24}>
        <DashboardCard
          bordered={false}
          title={
            <Title level={isMobile ? 5 : 4} weight={500}>
              {isBasePlan ? "You're on the Free Plan" : `You're on the ${subscriptionName} Plan`}
            </Title>
          }
        >
          <Row gutter={[16, 16]} vertical={isMobile}>
            <Col span={isMobile ? 24 : 12}>
              {isBasePlan && <BillingPlanFreeDescription apiCalls={limitApiCalls} />}
              {!isBasePlan && isExist(subscriptionPlan) && <PlanPaidDescription subscriptionPlan={subscriptionPlan} />}
            </Col>
            <Col span={isMobile ? 24 : 12}>
              <Title level={5}>
                Your Plan: {subscriptionName}
                <br />
                Usage: {usedApiCalls}
                <Progress percent={(usedApiCalls / limitApiCalls) * 100} showInfo={false} />
                {isOwner && (
                  <Button href={RouteEnum.WorkspacePlan.path} size='small' type={ButtonTypeEnum.Primary}>
                    Switch plan
                  </Button>
                )}
              </Title>
            </Col>
          </Row>
        </DashboardCard>
      </Col>
    </Row>
  );
};
